import styles from '../styles/timeline.module.css';
import { toolText } from '../texts';

export function ToolLine({ tool, target }: { tool: string; target: string | null }): React.JSX.Element | null {
  const text = toolText(tool, target);
  return text === '' ? null : <div className={styles.tool}>· {text}</div>;
}
